(function() { window.GUID_2d20fd8a_d932_4adb_9487_83107da0e707 = { getGuid: function() { return "2d20fd8a-d932-4adb-9487-83107da0e707"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-mytodos',
                        callback: function (control, e) {
                            control.$Container.offon('click.todo-pay', 'div.my-todo-box', function (e) {
                                e.stopImmediatePropagation();
                                e.preventDefault();
                                let $this = $(this);
                                CS.DOM.$body.offon("payment-done.todo", function () {
                                    control.RefreshContent();
                                });
                                let wf = new CS.Controls.SportEventFees();
                                wf.ShowModal($this.data('href'));
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=mytodos.js.map
